<strong>Unable to be Remotely Proofed</strong>

<br />

Reference Number: <strong>{{ referenceNumber }}</strong>

<br /><br />

<strong
  ><u
    >We cannot verify your identity. Please check for errors in the information
    entered.</u
  ></strong
>

<ul>
  <li>
    If you recently changed your name, address, or phone number, you might need
    to use your prior information.
  </li>
  <li>
    Please enter information that is most likely to be directly associated with
    you - such as what is shown on your credit report or on your financial
    accounts.
  </li>
  <li>
    Do not use your work phone number or email in the personal phone number and
    email entries.
  </li>
</ul>

<br /><br />

Due to incorrect answers, we were unable to Remote Identity Proof your details.
There are two options to complete registration.

<br /><br />

<strong><u>Option 1: Retry Remote Identity Proofing</u></strong>

<ol>
  <li>
    If you think you know what you entered incorrectly and would like to try
    again, please select <strong>"Retry Remote Proofing"</strong> back on the
    Profile Information page
    <a target="_self" href="/register/profile-info"> here.</a>
  </li>
  <li>Follow the steps to proceed.</li>
</ol>

<br />

<strong> <u>Option 2: Call Experian to verify your identity</u></strong>

<ol>
  <li>
    If you think you have entered the correct information, please contact
    Experian Verification Support Services at
    <strong href="tel:+1833-203-6550">1-833-203-6550</strong> and provide your
    <strong>Reference Number: {{ referenceNumber }}</strong>
  </li>
  <li>
    If Experian is able to successfully identity proof you over the phone,
    select <strong>"Enter Reference Number"</strong> back on the Profile
    information page
    <a target="_self" href="/register/profile-info"> here.</a>
  </li>
  <li>Follow the steps to proceed.</li>
</ol>

<br />

Detailed instructions have also been sent to your email address. If you need
additional assistance completing registration, please
<a target="_blank" href="/login/contact">contact</a> your application's help
desk.
